import React from 'react';
import { string, shape, bool } from 'prop-types';

const pedestrian_detection_sphere = ({ className, colors, checked = true }) => (
  <svg viewBox="0 0 400 400" className={className}>
    <path
      d="m200 400c110.46 0 200-89.54 200-200s-89.54-200-200-200-200 89.54-200 200 89.54 200 200 200z"
      fill={checked ? colors.brand.primary : '#E9EAEC'}
      fillRule="evenodd"
    />
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="matrix(6 0 0 6 0 0) translate(6,8)"
      fill={checked ? '#fff' : '#A4A8B2'}
    >
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M10.9 37.1L13.7 39.1C 18 32.8 19.1 24.8 16.6 17.6C 15.8 15.2 14.6 13 13.1 11L13.1 11L10.3 13.1C 11.6 14.8 12.6 16.7 13.3 18.7C 15.5 24.8 14.6 31.7 10.9 37.1z"
        stroke="none"
      />
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M7.4 20.1C 9.1 24.9 8.3 30.3 5.4 34.5L5.4 34.5L8.2 36.5C 11.8 31.4 12.7 24.8 10.6 19C 9.9 17 9 15.2 7.7 13.6L7.7 13.6L5 15.7C 6 17 6.8 18.5 7.4 20.1z"
        stroke="none"
      />
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M43.4999 43L35.9999 32.5L38.0999 18.6C 38.5999 15.6 36.2999 13 33.2999 13C 32.0999 13 30.8999 13.5 30.0999 14.2C 29.9999 14.2 29.8999 14.3 29.8999 14.3L29.8999 14.3L22.8999 19.3C 22.4999 19.6 22.1999 20 22.0999 20.4L22.0999 20.4L20.0999 28.4C 19.7999 29.5 20.4999 30.6 21.5999 30.8C 21.7999 30.8 21.8999 30.9 22.0999 30.9C 22.9999 30.9 23.7999 30.3 23.9999 29.4L23.9999 29.4L25.7999 22.1L28.0999 20.4L27.1999 27.5C 26.9999 28.8 27.3999 30 28.0999 31L28.0999 31L39.4999 46C 40.2999 47.1 41.8999 47.3 42.9999 46.5C 43.6999 46 43.9999 45.3 43.9999 44.5C 43.9999 44 43.7999 43.5 43.4999 43z"
        stroke="none"
      />
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M35 11C 37.2091 11 39 9.20914 39 7C 39 4.79086 37.2091 3 35 3C 32.7909 3 31 4.79086 31 7C 31 9.20914 32.7909 11 35 11z"
        stroke="none"
      />
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M28.8 36.9L32.1 41.2L28.5 46C 27.7 47.1 26.1 47.3 25 46.5C 24.3 46 24 45.3 24 44.5C 24 44 24.2 43.5 24.5 43L24.5 43L28.8 36.9z"
        stroke="none"
      />
      <path
        transform="matrix(1 0 0 1 0 0)"
        d="M43 30.7C 42.7 30.9 42.3 31 42 31C 41.3 31 40.7 30.7 40.3 30.1L40.3 30.1L39.6 29L40.5 22.9L43.7 28C 44.2 28.9 44 30.1 43 30.7z"
        stroke="none"
      />
    </g>
  </svg>
);

pedestrian_detection_sphere.propTypes = {
  className: string,
  colors: shape(),
  checked: bool,
};

export default pedestrian_detection_sphere;
